import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OMEGA3_FAQS } from '../data/omega3Data';
import { Icons } from '../../elements/icon/resolver';

const Omega3Faq = () => {
  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(-1);
  const ChevronDownIcon = Icons.chevronDown;
  const ChevronUpIcon = Icons.chevronUp;

  return (
    <section className="t-bg-surface t-py-8 t-pb-24">
      <div className="container !t-max-w-[840px]">
        <div className="t-mb-8 t-text-center">
          <h2
            className="!t-m-0 t-text-[32px] md:t-text-[42px] t-leading-[1.1] t-text-navy"
            style={{ fontFamily: 'DM Serif Display, serif' }}
          >
            {t('Omega3_Faq_Title')}
          </h2>
        </div>
        <div className="t-grid t-gap-2.5">
          {OMEGA3_FAQS.map((faq, index) => {
            const isOpen = index === openIndex;

            return (
              <div
                key={faq.questionKey}
                className="t-overflow-hidden t-rounded-[12px] t-border t-border-g200 t-bg-white"
              >
                <button
                  type="button"
                  className="t-flex t-w-full t-items-center t-justify-between t-gap-5 t-border-0 t-bg-transparent t-px-5 t-py-3 t-text-left t-text-[17px] t-font-[700] t-text-navy"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                >
                  <span>{t(faq.questionKey)}</span>
                  {isOpen ? (
                    <ChevronUpIcon color="#116D6E" size="20" />
                  ) : (
                    <ChevronDownIcon color="#116D6E" size="20" />
                  )}
                </button>
                <div
                  className={`t-overflow-hidden t-transition-all t-duration-300 ${
                    isOpen ? 't-max-h-[320px] t-px-5 t-pb-5' : 't-max-h-0'
                  }`}
                >
                  <p className="!t-m-0 t-text-[16px] t-leading-[1.7] t-text-g500">{t(faq.answerKey)}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Omega3Faq;
